

export const FETCH_RATEADMIN_LORADJUSTMENTS_LIST = {
    START: 'FETCH_RATEADMIN_LORADJUSTMENTS_LIST_START',
    SUCCESS: 'FETCH_RATEADMIN_LORADJUSTMENTS_LIST_SUCCESS',
    ERROR: 'FETCH_RATEADMIN_LORADJUSTMENTS_LIST_ERROR',
  };
  export const TOAST = {
    RESET: 'RESET_TOAST',
  };
  export const FETCH_RATEADMIN_LORADJUSTMENTS_INIT="FETCH_RATEADMIN_LORADJUSTMENTS_INIT"
  export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY =
  'SET_DELETE_CONFIRMATION_POPUP_VISIBILITY';


  
export const INIT_CREATE_RATEADMIN_LORADJUSTMENTS_SCREEN =
'INIT_CREATE_RATEADMIN_LORADJUSTMENTS_SCREEN';

export const CREATE_RATEADMIN_LORADJUSTMENTS = {
START: 'CREATE_RATEADMIN_LORADJUSTMENTS_START',
SUCCESS: 'CREATE_RATEADMIN_LORADJUSTMENTS_SUCCESS',
ERROR: 'CREATE_RATEADMIN_LORADJUSTMENTS_ERROR',
};

export const EDIT_RATEADMIN_LORADJUSTMENTS = {
START: 'EDIT_RATEADMIN_LORADJUSTMENTS_START',
SUCCESS: 'EDIT_RATEADMIN_LORADJUSTMENTS_SUCCESS',
ERROR: 'EDIT_RATEADMIN_LORADJUSTMENTS_ERROR',
};

export const FETCH_RATEADMIN_LORADJUSTMENTS_DETAIL = {
  START: 'FETCH_RATEADMIN_LORADJUSTMENTS_DETAIL_START',
  SUCCESS: 'FETCH_RATEADMIN_LORADJUSTMENTS_DETAIL_SUCCESS',
  ERROR: 'FETCH_RATEADMIN_LORADJUSTMENTS_DETAIL_ERROR',
};
export const EXPORT_RATEADMIN_LORADJUSTMENTS = {
  START: 'EXPORT_RATEADMIN_LORADJUSTMENTS_START',
  SUCCESS: 'EXPORT_RATEADMIN_LORADJUSTMENTS_SUCCESS',
  ERROR: 'EXPORT_RATEADMIN_LORADJUSTMENTS_ERROR',
};
export const RATEADMIN_LORADJUSTMENTSDD = {
  START: 'RATEADMIN_LORADJUSTMENTSDD_START',
  SUCCESS: 'RATEADMIN_LORADJUSTMENTSDD_SUCCESS',
  ERROR: 'RATEADMIN_LORADJUSTMENTSDD_ERROR',
};
export const DELETE_RATEADMIN_LORADJUSTMENTS = {
  START: 'DELETE_RATEADMIN_LORADJUSTMENTS_START',
  SUCCESS: 'DELETE_RATEADMIN_LORADJUSTMENTS_SUCCESS',
  ERROR: 'DELETE_RATEADMIN_LORADJUSTMENTS_ERROR',
};

export const RATEADMIN_LORADJUSTMENTS_SAVE_TABLE_STATE = 'RATEADMIN_LORADJUSTMENTS_SAVE_TABLE_STATE';